/* eslint-disable jsx-control-statements/jsx-use-if-tag */
import React, { useEffect, useState } from 'react'

import './profile.scss'
import './_unifiedlogin.scss'
import './Handlepiclick'
import { MLContainers } from '../../newComponents/UnifiedLogin'

const MobContainer = ({
  setIsPOpaque = () => {},
  setIsGOpaque = () => {},
  setIsEOpaque = () => {},
  isMOpaque,
  userDetail,
  setUserDetail,
  setToastMessagex = () => {}
}) => {
  const [isNumberEditable, setIsNumberEditable] = useState(true)
  const [userNumber, setUserNumber] = useState(
    userDetail ? userDetail.mobile : ''
  )
  const [page, setPageName] = useState('')
  const handlemobClick = () => {
    setPageName('SIGNINML')

    setIsNumberEditable(false)
    setIsEOpaque(true)
    setIsGOpaque(true)
    setIsPOpaque(true)
  }

  useEffect(() => {
    setUserNumber(userDetail ? userDetail.mobile : '')
  }, [userDetail])

  return (
    <>
      {isNumberEditable ? (
        <div
          className={` fs-2 c-grey-title mt-6 ${
            isMOpaque ? 'op-low' : 'op-high'
          }`}
        >
          Mobile Number
          <div className="flex flex-row">
            {userDetail && userDetail.mobile === '' ? (
              <span className="fs-4 " style={{ color: '#B3B3B3' }}>
                Not provided
              </span>
            ) : (
              <span className="fs-4 fw-500" style={{ color: '#1A1A1A' }}>
                {userDetail.mobile}
              </span>
            )}
            <span className="heading5">
              <a onClick={handlemobClick}>Edit</a>
            </span>
          </div>
          <div className="dotted_line" />
        </div>
      ) : (
        <div className="mt-6">
          <MLContainers
            page={page}
            isShowing={true}
            setIsNumberEditable={setIsNumberEditable}
            isNumberEditable={isNumberEditable}
            setIsGOpaque={setIsGOpaque}
            setIsPOpaque={setIsPOpaque}
            setIsEOpaque={setIsEOpaque}
            setUserNumber={setUserNumber}
            userNumber={userNumber}
            userDetail={userDetail}
            setUserDetail={setUserDetail}
            setToastMessagex={setToastMessagex}
          />
        </div>
      )}
    </>
  )
}
export default MobContainer
